/**
 * OrbDocTutorialsAdvancedFullAppARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsAdvancedFullAppARDocScreen
 */

import { useOrbDocTutorialsAdvancedFullAppARDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsAdvancedFullAppARDocScreenLogic';
import type { OrbDocTutorialsAdvancedFullAppARDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsAdvancedFullAppARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsAdvancedFullAppARDocView as OrbDocTutorialsAdvancedFullAppARDocViewEntity } from '@app/shared';
import { OrbDocTutorialsAdvancedFullAppARDocBodyView } from '@/components/traits/OrbDocTutorialsAdvancedFullAppARDocBodyView';
import { OrbDocTutorialsAdvancedFullAppARDocFooterView } from '@/components/traits/OrbDocTutorialsAdvancedFullAppARDocFooterView';
import { OrbDocTutorialsAdvancedFullAppARDocHeaderView } from '@/components/traits/OrbDocTutorialsAdvancedFullAppARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsAdvancedFullAppARDocScreenViewProps {
  config?: Partial<OrbDocTutorialsAdvancedFullAppARDocScreenConfig>;
}

export function OrbDocTutorialsAdvancedFullAppARDocScreenView({ config: propsConfig }: OrbDocTutorialsAdvancedFullAppARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsAdvancedFullAppARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsAdvancedFullAppARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsAdvancedFullAppAR" trait="OrbDocTutorialsAdvancedFullAppARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsAdvancedFullAppARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsAdvancedFullAppARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsAdvancedFullAppARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsAdvancedFullAppARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsAdvancedFullAppARDocScreenView;
